var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datetime',{attrs:{"input-class":"form-control","value":_vm.value,"type":"date","phrases":{ ok: 'Confirmar', cancel: 'Fechar' },"value-zone":"local"},on:{"input":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }